<template>
  <div class="border">
    <div class="top-line medium">
      <span>{{ topLineText }}</span>
      <button
        v-if="isTooltipAvailableInTopLine"
        class="tooltip"
        data-testid="tooltip-top-line"
        @click="openModal"
      >
        <i class="tooltip-small" />
      </button>
    </div>

    <div class="bottom-line medium">
      <a
        v-if="signInButtonVisible"
        :href="signInLink"
        class="link menu-link-med"
        data-testid="signIn-link"
      >
        <span>{{ signInText }}</span>
        <i class="chevron-medium-right-black" />
      </a>

      <div
        v-else
        class="text"
      >
        <span>{{ bottomLineText }}</span>
        <button
          v-if="isTooltipAvailableInBottonLine"
          class="tooltip"
          data-testid="tooltip-bottom-line"
          @click="openModal"
        >
          <i class="tooltip-small" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import { getUserIds } from '@utils/cookiesUtils';
import { useLoyalty } from '@composables/useLoyalty';
import { useSlideout } from '@composables/utils/useSlideout';
import { capitalize } from '@utils/capitalize';
import { REDIRECT_MAP } from '../../../constants/common';

const { isSignedIn } = getUserIds();
const {
  isGold, isPlatinum, isUserNonLoyalist, tierName,
} = useLoyalty();
const { showSlideout } = useSlideout();

const signInDefaultText = 'Sign in';
const signInLoyaltyText = 'Join Star Rewards';

const topLineDefaultText = 'Members get free shipping at $25 + free returns';
const topLineLoyaltyText = `Star Rewards ${capitalize(tierName.value)}:`;
const bottomLineDefaultText = 'free shipping at $25 + free returns';
const bottomLinePremiumLoyaltyText = 'free shipping, no minimum + free returns';

const isTooltipAvailableInTopLine = !isSignedIn || isUserNonLoyalist.value;
const isTooltipAvailableInBottonLine = isSignedIn && !isUserNonLoyalist.value;
const signInButtonVisible = !isTooltipAvailableInBottonLine;

const topLineText = (isSignedIn && !isUserNonLoyalist.value) ? topLineLoyaltyText : topLineDefaultText;
const bottomLineText = (isSignedIn && (isGold.value || isPlatinum.value)) ? bottomLinePremiumLoyaltyText : bottomLineDefaultText;
const signInText = isSignedIn ? signInLoyaltyText : signInDefaultText;
const signInLink = isSignedIn ? REDIRECT_MAP.loyaltySignIn : REDIRECT_MAP.signIn;

function openModal() {
  showSlideout({
    id: 'shippingAndReturns',
    title: 'Shipping & Returns',
    component: defineAsyncComponent(
      /* istanbul ignore next */ () => import(/* webpackChunkName: "ShippingAndReturnsSlideout" */ './slideouts/ShippingAndReturnsSlideout'),
    ),
    backable: false,
  });
}
</script>

<style lang="scss" brand="mcom" scoped>
@import "~settingSCSS";
@import "@csgIcons/_tooltip-small.scss";
@import "@csgIcons/_chevron-medium-right-black.scss";

.border {
  border: 1px solid $gray-4-color;
  border-radius: rem-calc(5);
  @include padding-top-xs;
  @include padding-bottom-xs;
  @include padding-left-xxs;
  @include padding-right-xxs;
  text-align: center;
}

.top-line,
.bottom-line {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tooltip {
  margin-left: rem-calc(4);
  cursor: pointer;
}

.bottom-line {
  @include margin-top-xxs;

  .link, .text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
